import { environment } from '@environments/environment';

export function extractDomain(email: string | undefined): string | null {
  const regex = /@([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/;
  const match = email?.match(regex);
  return match ? match[1] : null; // Return the domain if matched, otherwise null
}

export function clusterFromEnvironment(): string {
  const CLUSTER_BY_ENVIRONMENT = {
    production: 'aks-prod',
    staging: 'aks-staging',
    development: 'aks-dev',
  } as const;
  const locationSuffix = environment.isUsCluster ? '-eus2' : '-gwc';
  return CLUSTER_BY_ENVIRONMENT[environment.environment] + locationSuffix;
}
